import { cn } from '@/lib/utils'

type ProgressColor = 'emerald' | 'amber' | 'rose' | 'blue' | 'navy' | 'violet'

interface ProgressProps {
  value: number
  max?: number
  color?: ProgressColor
  size?: 'sm' | 'md'
  className?: string
}

const colorStyles: Record<ProgressColor, string> = {
  emerald: 'bg-gradient-to-r from-emerald-400 to-emerald-500',
  amber: 'bg-gradient-to-r from-amber-400 to-amber-500',
  rose: 'bg-gradient-to-r from-rose-400 to-rose-500',
  blue: 'bg-gradient-to-r from-blue-400 to-blue-500',
  navy: 'bg-navy-700',
  violet: 'bg-gradient-to-r from-violet-400 to-violet-500',
}

export function Progress({ value, max = 100, color = 'emerald', size = 'md', className }: ProgressProps) {
  const pct = Math.min(100, Math.max(0, (value / max) * 100))
  return (
    <div
      className={cn(
        'w-full bg-slate-100 rounded-full overflow-hidden',
        size === 'sm' ? 'h-1.5' : 'h-2',
        className
      )}
    >
      <div
        className={cn('h-full rounded-full transition-all', colorStyles[color])}
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
